import React from 'react'
import styles from './start.module.css'
import {Text, Button} from '../../components'
import {useIntl} from 'react-intl'
import { useNavigate } from 'react-router-dom'
import useAppContext from '../../context/Context'
import '../../styles/animation.css'

const Start = () => {
    const intl = useIntl()
    const [selected,setSelected] = React.useState('Valencià')
    const navigate = useNavigate()
    const LANGS = ['Valencià', 'Castellano', 'English']
    const { language, setLanguage } = useAppContext()

    const handleLanguage = data => {
        switch(data){
            case 'Valencià': {
                setLanguage && setLanguage('vl')
                setSelected('Valencià')
            }
            break
            case 'English': {
                setLanguage && setLanguage('en')
                setSelected('English')
            }
            break
            default: {
                setLanguage && setLanguage('cs')
                setSelected('Castellano')
            }
            break
        }
    }

    return(
            <div className={styles.container}>
                <div className={styles.container_body}>
                    <div className={styles.first_child}>
                        <Text className={styles.body_title}>Fadrines.</Text>
                        <Text className={styles.body_text}>{ intl.formatMessage({ id: 'start.text'})}</Text>
                    </div>
                    <div className={`flex-row full-w align-center content-center ${styles.buttons}`}>
                        {
                            LANGS.map(item =>(
                                <Button customClasses={
                                    selected === item ? styles.button_selected : ''
                                } key={item} onClick={()=>handleLanguage(item)}>{item}</Button>
                            ))
                        }
                    </div>
                    <div className={styles.footer}>
                        <div onClick={() => navigate("/video-intro")}>
                            <span>{ intl.formatMessage({ id: 'home.start'})}</span>
                            <div className={styles.arrow} />
                        </div>
                    </div>
                    <div className={`flex-row align-center ${styles.legal_texts}`} style={{
                        width: language === "en" ? "60%" : "80%",
                    }}>
                        <a href={process.env.REACT_APP_LEGAL_WARNING} target="_blank" rel="noreferrer">{intl.formatMessage({id: "legal-warning"})}</a>
                        <a href={process.env.REACT_APP_PRIVACY_POLICY} target="_blank" rel="noreferrer">{intl.formatMessage({id: "privacy-policy"})}</a>
                        <a href={process.env.REACT_APP_ACCESSIBILITY} target="_blank" rel="noreferrer">{intl.formatMessage({id: "accessibility"})}</a>
                    </div>
                </div>
                <div className={`flex-row absolute ${styles.icons}`}>
                    <img src='/images/logos.png' alt='Diputación y Letno Logo' />
                </div>
            </div>
    )
}

export default Start